module.exports = __webpack_public_path__ + "static/media/purple-and-yellow-iris.58bb8908.jpg";